const home = {
  // 首页信息
  homeindex: `/pcApi/v1/homeapi/homeindex/info`,
  // 首页新服推荐换一批
  get_random_open_list: `/pcApi/v1/homeapi/homeindex/get_random_open_list`,
  // 发现页信息
  byRand: `/pcApi/v1/homeapi/FindGame/findAllGameListByRand`,
  // 排行页信息
  withRank: `/pcApi/v1/homeapi/FindGame/getGameListWithRank`,
  // 排行页信息 - java - 白金泽
  withRankJava: `/authApi/box/v1/rankGames`,
  // 排行页游戏标签
  getAllLabel: `/authApi/box/v1/getAllLabel`,
  // 版本与标签接口
  tagList: `/pcApi/v1/homeapi/FindGame/getAllVersionAndTagList`,
  // php-推荐页-开服列表筛选
  get_index_open_list: `/pcApi/v1/homeapi/Homeindex/get_index_open_list`,
  // 推荐页-开服列表筛选 - java - 白金泽
  get_index_open_list_java: `/authApi/adgame/ad/todayGames`,
  // get_index_open_list: `/authApi/box/v1/home/IndexOpenList`,
  // 新服页-今日开服
  // getTodayNewServerList: `/authApi/box/v1/todayGames`,
  getTodayNewServerList: `/pcApi/v2/homeapi/FindGame/getTodayNewServerList`,
  // 新服页-即将开服
  getFutureNewServerList: `/pcApi/v1/homeapi/FindGame/getFutureNewServerList`,
  // 时间段配置获取
  getTimeSection: `/pcApi/v1/homeapi/FindGame/getTimeSection`,
  // 获取评论
  commentList: `/pcApi/v1/homeapi/comment/commentList`,
  // 我的评论
  myComment: `/pcApi/v1/homeapi/comment/myComment`,
  // 添加评论
  addComment: `/pcApi/v1/homeapi/comment/addComment`,
  // 评论回复列表
  userCommentList: `/pcApi/v1/homeapi/comment/userCommentList`,
  // 回复评论
  addUserComment: `/pcApi/v1/homeapi/comment/addUserComment`,
  // 删除回复
  delUserComment: `/pcApi/v1/homeapi/comment/delUserComment`,
  // 删除评论
  delComment: `/pcApi/v1/homeapi/comment/delComment`,
  // 评论页点赞
  commentPraise: `/pcApi/v1/homeapi/comment/commentPraise`,
  // 回复页点赞
  replyPraise: `/pcApi/v1/homeapi/comment/replyPraise`,
  // 版本更新
  versionInfo: `/pcApi/v1/homeapi/Homeindex/versionInfo2`,
  // 外壳版本更新
  coreVersion: `/pcApi/v1/homeapi/Homeindex/versionInfoShuck`,
  // 黑词库屏蔽
  getBlackWords: `/pcApi/v1/homeapi/Gameindex/getBlackWords`,
  // 上报错误信息
  sendCrash: `/pcApi/v1/homeapi/AppCrash/sendCrash`,
  // 新游推荐
  // NewGameList: `/pcApi/v1/homeapi/Gameindex/NewGameList`,
  NewGameList: `/authApi/box/v1/newGamesByPc`,
  // 获取QQ一键加群KEY
  getQQKey: `/pcApi/v1/homeapi/Homeindex/randomQqQunKey`,
  // 找服列表
  gameSort: `/pcApi/v1/homeapi/FindGame/gameSort`,
  // 找服列表(新)
  getGameSort: `/authApi/box/v1/getGameSort`,
  // 找服务列表(新新) -- java白金泽
  getGameSortByGroup: '/authApi/box/v2/getAdSortPcByGroup',
  // 找服务列表(新新新) -- 宋劲松
  gamesGroupsLabel: '/authApi/box/v1/games/groups/label',
  // 找服务列表(列表) -- java白金泽
  getGameSortByPage: '/authApi/box/v2/getGameSortByPage',
  // 游戏类型获取玩法一级分类id根据配置 -- java白金泽
  getPlayWayGroupIdByGameType: `/authApi/box/v2/getPlayWayGroupIdByGameType`,
  // pc首页必玩好服列表
  getMustPlayGames: `/authApi/box/v1/getMustPlayGames`,
  // pc首页必玩好服列表 -- 白金泽（4.1.0新增接口）
  getMustPlayGamesV2: `/authApi/box/v2/getMustPlayGames`,
  // 精选推荐-nav
  getHomeBannerSort: `/authApi/box/v1/getHomeBannerSort`,
  // 精选推荐
  getBannerList: `/authApi/box/v1/getBannerList`,
  // 开屏页广告
  adShow: `/authApi/ad/v1/adShow`,
  // 盒子检测更新
  getNewVersion: `/pcApi/v1/homeapi/Homeindex/versionInfo`,
  // 推荐-排行榜 -- java白金泽
  allRankGames: `/authApi/box/v1/allRankGames`,
  // 推荐-首页开服列表 -- java白金泽
  getLiveStatusByGameIds: `/authApi/show/v1/getLiveStatusByGameIds`,
  // 推荐-热门游戏推荐 -- java白金泽
  getPopularGamePage: `/authApi/box/v1/getPopularGamePage`,
  // pc专区展示控制 -- java白金泽
  getShowPcPrefecture: `/authApi/box/v1/getShowPcPrefecture`,
  // 推荐-pc展示控制热门游戏专栏是否展示 -- java白金泽
  getShowHotGame: `/authApi/box/v1/getShowHotGame`,
  // 根据区服ID隐藏直播 -- php 王志远
  ignoreLiveByChannel: `/pcApi/v1/homeapi/Homeindex/InternetBarChannel`,
  // 获取直播，充值协议的默认勾选
  defaultAgreement: `/pcApi/v1/homeapi/Homeindex/defaultAgreement`,
  // 悬浮窗入口列表
  getFloatPopupList: `/authApi/tip/v1/floatPopupList`,
  // 专区攻略帖子列表查询
  getSpecialTabGuidePost: `/authApi/box/v1/getSpecialTabGuidePost`,
  // 查询帖子是否可见
  isVisiblePost: `/authApi/forum/v1/isVisiblePost`,
  // 专区游戏Banner查询 /box/v1/getSpecialTabGameBanner
  getSpecialTabGameBanner: `/authApi/box/v1/getSpecialTabGameBanner`,
  // 今日游戏查询接口V3 新游推荐
  getTodayGamesV3: `/authApi/adgame/v3/ad/todayGames`,
  // 今日游戏查询接口V4 新游推荐
  getTodayGamesV4: `/authApi/adgame/v4/ad/todayGames`,
  // 今日游戏业务拓展信息查询
  getTodayGamesBizExtend: `/authApi/box/v1/todayGamesBizExtend`,
  // 获取榜单配置 - java - 李德国
  rankConfigList: `/authApi/user/rank/config/list`,
  // 保存榜单配置 - java - 李德国
  rankConfigSave: `/authApi/user/rank/config/save`,
  // 保存榜单配置 - java - 宋劲松
  rankGames: `/authApi/box/v1/rank/games`,
  // 获取找服筛选条件列表 - 李德国
  findServerFilterCriteria: `/authApi/box/v2/findServerFilterCriteria`,
  // 获取玩法新接口 - 李德国
  getAdSortLabels: `/authApi/box/v3/getAdSortLabels`,
  // 找服列表接口 - 宋劲松
  findGame: `/authApi/box/v1/find/games`,
  // 不感兴趣游戏触发接口 - 苏昕
  notInterested: `/authApi/user-portrait/interest-weight/users/not-interested`,
  // 游戏推荐接口 - 宋劲松
  recommendGames: `/authApi/box/v1/recommend/games`,
  // CPC 广告点击 - 林加汉
  adCpcClick: `/authApi/ad/v1/cpc/click`
};

export default home;
